import React, { useEffect, useState } from "react";
import { motion, useSpring, useMotionValue } from "framer-motion";

const CustomCursor = () => {
  const [isHovering, setIsHovering] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  // Position of the cursor (unfiltered)
  const cursorX = useMotionValue(-100);
  const cursorY = useMotionValue(-100);

  // Spring physics for the "follower" ring
  const springConfig = { damping: 25, stiffness: 250 };
  const followerX = useSpring(cursorX, springConfig);
  const followerY = useSpring(cursorY, springConfig);

  useEffect(() => {
    const moveCursor = (e) => {
      cursorX.set(e.clientX);
      cursorY.set(e.clientY);
      if (!isVisible) setIsVisible(true);
    };

    const handleMouseOver = (e) => {
      if (
        e.target.tagName === "A" ||
        e.target.tagName === "BUTTON" ||
        e.target.closest("button") ||
        e.target.closest("a")
      ) {
        setIsHovering(true);
      } else {
        setIsHovering(false);
      }
    };

    const handleMouseOut = () => {
      setIsVisible(false);
    };

    const handleMouseEnter = () => {
      setIsVisible(true);
    };

    window.addEventListener("mousemove", moveCursor);
    window.addEventListener("mouseover", handleMouseOver);
    document.addEventListener("mouseleave", handleMouseOut);
    document.addEventListener("mouseenter", handleMouseEnter);

    return () => {
      window.removeEventListener("mousemove", moveCursor);
      window.removeEventListener("mouseover", handleMouseOver);
      document.removeEventListener("mouseleave", handleMouseOut);
      document.removeEventListener("mouseenter", handleMouseEnter);
    };
  }, [cursorX, cursorY, isVisible]);

  if (!isVisible) return null;

  return (
    <>
      {/* Main dot - follows exactly */}
      <motion.div
        style={{
          position: "fixed",
          left: 0,
          top: 0,
          x: cursorX,
          y: cursorY,
          width: 8,
          height: 8,
          borderRadius: "50%",
          backgroundColor: "#00E5FF",
          pointerEvents: "none",
          zIndex: 10001,
          translateX: "-50%",
          translateY: "-50%",
        }}
      />
      {/* Follower ring - has spring physics */}
      <motion.div
        style={{
          position: "fixed",
          left: 0,
          top: 0,
          x: followerX,
          y: followerY,
          width: 32,
          height: 32,
          borderRadius: "50%",
          border: "1.5px solid #00E5FF",
          pointerEvents: "none",
          zIndex: 10000,
          translateX: "-50%",
          translateY: "-50%",
          backgroundColor: "transparent",
        }}
        animate={{
          scale: isHovering ? 1.8 : 1,
          backgroundColor: isHovering ? "rgba(0, 229, 255, 0.1)" : "transparent",
        }}
      />
    </>
  );
};

export default CustomCursor;
